/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, FullscreenDialog, Typography, Typography2 } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

import WarningIcon from './images/warning-icon.svg';

type ErrorViewProps = {
  headingText?: string;
  bodyText?: string;
};

const styles = {
  container: (theme: Theme) => css`
    padding-top: ${theme.spacing(112)};
    overflow-y: auto;

    ${theme.breakpoints.down('sm')} {
      padding-top: ${theme.spacing(32)};
    }
  `,
  icon: (theme: Theme) => css`
    width: 70px;
    margin-bottom: ${theme.spacing(32)};
  `,
  pageTitle: (theme: Theme) => css`
    margin-bottom: ${theme.spacing(8)};
  `,
};

export const ErrorView = ({ headingText, bodyText }: ErrorViewProps) => {
  const { Content, Actions } = FullscreenDialog;
  return (
    <>
      <Content id="enrollmentDialogContent" aria-live="polite" aria-atomic="true">
        <div css={styles.container}>
          <img css={styles.icon} src={WarningIcon} alt={_t(`Warning icon`)} />
          <Typography component="h1" variant="h1semibold" css={styles.pageTitle}>
            {headingText || _t(`This page won't load`)}
          </Typography>
          <Typography2 component="p" variant="bodyPrimary">
            {bodyText || _t('There seems to be an error loading this page, please try again.')}
          </Typography2>
        </div>
      </Content>
      <Actions>
        <Button variant="secondary" onClick={() => window.location.reload()}>
          {_t('Retry')}
        </Button>
      </Actions>
    </>
  );
};

export default ErrorView;
